<script>
	const urlUtilities = require('utilities/urlUtilities');
	const {
		fireEvent,
		events: { RECOMMENDATION_CLICK }
	} = require('utilities/analyticsUtilities');

	module.exports = {
		props: {
			article: {
				required: true
			},
			recommendation: {
				required: true
			}
		},
		components: {
			overflowText: require('components/overflow-text.vue').default
		},
		modelData: ['articleEntryPoint'],
		computed: {
			productUrl() {
				return urlUtilities.getProductURL(this.article);
			}
		},
		methods: {
			onArticleClick() {
				this.$emit('recommendation-click');
				this.articleEntryPoint = 'recommended-article-card';
				fireEvent(RECOMMENDATION_CLICK, {
					target: this.article.uuid,
					page: 'find-content',
					source: 'recommended-content-panel',
					type: this.recommendation.type
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.recommended-article-card {
		display: flex;
		flex-direction: column;
		margin: 1rem;
		max-width: 20rem;
		border: 1px solid $c-grey;
		box-shadow: 0 0 10px 2px rgba(112, 144, 176, 0.15);

		img {
			object-fit: cover;
			object-position: top center;
			max-height: 13rem;
			min-height: 8rem;

			@include media(lg) {
				max-height: 10rem;
			}
		}

		.article-info {
			padding: 0.5rem 1rem 1rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			flex-grow: 1;
		}

		.article-title {
			font-size: 1.125rem;
		}

		.article-meta {
			display: flex;
			justify-content: space-between;
			margin-top: 1rem;
			color: $c-slate-muted;
		}
	}
</style>
<template>
	<a
		class="recommended-article-card tooltip-top"
		:href="productUrl"
		@click="onArticleClick">
		<img
			:src="article.img_highres2"
			:alt="article.imgAlt" />
		<div class="article-info">
			<overflow-text
				class="article-title"
				:text="article.title"
				lines="2"
				focusable-wrapper></overflow-text>
			<div class="article-meta">
				<span
					v-if="article.grades && article.grades.length"
					class="grade"
					>{{ article.grades | getGradeRangeWithOrdinal }}</span
				>
				<span
					v-if="article.wordCount"
					class="word-count"
					>{{ article.wordCount }} words</span
				>
			</div>
		</div>
	</a>
</template>
